import { withApollo } from '@apollo/client/react/hoc';

import TickerSearchAutocomplete from 'buyside/components/presentation/UserAccount/WatchlistedTickers/tickerSearchAutocomplete';

export default withApollo(TickerSearchAutocomplete);
